module.exports = __webpack_public_path__ + "static/media/creature-desk.f6e67e67.svg";